import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import {
  ExpertProfileAccessState,
  useExpertProfilePage,
} from '~/modules/connect/useExpertProfilePage';
import { ExpertProfilePageSkeleton } from '~/modules/connect/ExpertProfilePageSkeleton';
import {
  ExpertProfileErrorState,
  ExpertProfileErrorVariant,
} from '~/modules/connect/ExpertProfileErrorState';
import { ExpertProfileContent } from '~/modules/connect/ExpertProfileContent';
import { ExpertProfileModals } from '~/modules/connect/ExpertProfileModals';

function ExpertProfilePage() {
  const navigate = useNavigate();
  const {
    accessState,
    expert,
    isLoading,
    error,
    isOwnProfile,
    currentUser,
    mattersWithoutExpert,
    isCreateMatterModalOpen,
    setIsCreateMatterModalOpen,
    isAddToMatterModalOpen,
    setIsAddToMatterModalOpen,
    openAddToMatterModal,
    lastActive,
    handleCreateMatter,
    isCreatingMatter,
    experts,
  } = useExpertProfilePage();

  if (isLoading) {
    return <ExpertProfilePageSkeleton />;
  }

  if (error) {
    return (
      <ExpertProfileErrorState
        variant={ExpertProfileErrorVariant.Error}
        message={error.message}
        onBack={() => navigate('/matters')}
      />
    );
  }

  if (accessState === ExpertProfileAccessState.NotFound || !expert) {
    return (
      <ExpertProfileErrorState
        variant={ExpertProfileErrorVariant.NotFound}
        onBack={() => navigate('/matters')}
      />
    );
  }

  return (
    <Box>
      <ExpertProfileContent
        expert={expert}
        isOwnProfile={isOwnProfile}
        currentUser={currentUser}
        mattersWithoutExpert={mattersWithoutExpert}
        lastActive={lastActive}
        setIsCreateMatterModalOpen={setIsCreateMatterModalOpen}
        onOpenAddToMatterModal={openAddToMatterModal}
        onBack={() => navigate('/matters')}
      />

      <ExpertProfileModals
        expert={expert}
        isOwnProfile={isOwnProfile}
        isCreateMatterModalOpen={isCreateMatterModalOpen}
        setIsCreateMatterModalOpen={setIsCreateMatterModalOpen}
        isAddToMatterModalOpen={isAddToMatterModalOpen}
        setIsAddToMatterModalOpen={setIsAddToMatterModalOpen}
        mattersWithoutExpert={mattersWithoutExpert}
        experts={experts}
        handleCreateMatter={handleCreateMatter}
        isCreatingMatter={isCreatingMatter}
      />
    </Box>
  );
}

const ProfilePaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const SectionTitleSmall = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
}));

export { ProfilePaper, SectionTitle, SectionTitleSmall };
export default ExpertProfilePage;
